/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import {
  Wrapper,
  PreTitle,
  Title,
  Text
} from '../components/ui';

import Visual from '../components/visual';

const OneVisualLayout = ({
  section,
  subSection,
  title,
  paragraph1,
  paragraph2,
  visual,
  visualProps = {},
}) => (
  <Wrapper>
    {(section || subSection) && <PreTitle>{section}{subSection ? ` | ${subSection}` : ''}</PreTitle>}
    <Title>{title}</Title>
    <Text>
      {paragraph1}
    </Text>
    <Visual data={visual} {...visualProps} />
    {paragraph2 && <Text>
      {paragraph2}
    </Text>}
  </Wrapper>
);

export default OneVisualLayout;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/layouts/one-visual.js